
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cancel-appointment",
      function () {
        return require("private-next-pages/cancel-appointment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cancel-appointment"])
      });
    }
  